import { Paper } from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { getUserData } from "../helper/baseFunctions";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text-white"
      align="left"
      {...props}
      sx={{
        fontSize: { xs: "0.6rem", sm: "0.8rem", md: "inherit" },
        whiteSpace: "nowrap",
        marginRight: props.emailToShow ? "16px" : 0,
        ...props.sx,
      }}
    >
      {"Copyright © "}
      <Link color="inherit" href="/">
        meepl
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const Footer = () => {
  const userData = getUserData();
  const emailToShow = userData?.office_email || userData?.email_id;
  const theme = useTheme();

  return (
    <Paper
      sx={{
        zIndex: "9999",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette?.dark?.main
            : theme.palette?.root?.main,
        color:
          theme.palette.mode === "dark"
            ? theme.palette.common.white
            : theme.palette.text.primary,
        borderRadius: { xs: 0, sm: 1 },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: emailToShow ? "space-between" : "flex-end",
          alignItems: "center",
          padding: "0 16px",
        }}
        sx={{
          minHeight: {
            xs: "18px",
            sm: "22px",
            md: "24px",
            lg: "26px",
            xl: "28px",
          },
        }}
      >
        <Copyright emailToShow={emailToShow} />
        {emailToShow && (
          <Typography
            variant="body2"
            color="text-white"
            align="right"
            sx={{
              fontSize: { xs: "0.6rem", sm: "0.8rem", md: "inherit" },
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "60%",
            }}
          >
            Logged in as {emailToShow}
          </Typography>
        )}
      </div>
    </Paper>
  );
};

export default Footer;